import {
  UnavailableReceiptView,
  ReceiptLineItems,
  ReceiptClaimCtaBanner,
  Claim,
} from './components';

export const Receipt = {
  UnavailableView: UnavailableReceiptView,
  LineItems: ReceiptLineItems,
  ClaimBanner: ReceiptClaimCtaBanner,
  Claim,
};

export { useReceiptMachine, type ReceiptMachineImplementations } from './machine';
